import { createContext, useContext, useState, useCallback } from 'react';
import { useAuth } from './AuthContext';

const GuestContext = createContext(null);

export function GuestProvider({ children }) {
  const { user, isAuthenticated } = useAuth();
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [promptAction, setPromptAction] = useState('');

  const isGuest = !isAuthenticated || !user;

  const requireAuth = useCallback((actionLabel = 'continue') => {
    if (isGuest) {
      setPromptAction(actionLabel);
      setShowLoginPrompt(true);
      return false;
    }
    return true;
  }, [isGuest]);

  const dismissPrompt = useCallback(() => {
    setShowLoginPrompt(false);
    setPromptAction('');
  }, []);

  return (
    <GuestContext.Provider value={{ isGuest, requireAuth, showLoginPrompt, promptAction, dismissPrompt }}>
      {children}
    </GuestContext.Provider>
  );
}

export function useGuest() {
  const ctx = useContext(GuestContext);
  if (!ctx) throw new Error('useGuest must be used within GuestProvider');
  return ctx;
}
